type Props = () => string;

const now: Props = () => {
  let [date, offset] = [new Date(), new Date().getTimezoneOffset()];
  date.setMinutes(date.getMinutes() - offset);
  return date.toISOString();
};

export default now;
